import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29de699a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row left" }
const _hoisted_2 = { class: "col-md-2" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "Paper", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "null" }, "None", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "User", -1))
const _hoisted_9 = { class: "row middle" }
const _hoisted_10 = { class: "col-md-9" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_14 = { class: "col-md-9" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "Ecommerce", -1))
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "Print", -1))
const _hoisted_21 = { class: "row left" }
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "PopupNotification" }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("select", {
            id: "Type",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.PaperId) = $event)),
            class: "form-select",
            "aria-label": "Select Type"
          }, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.papers, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.Id,
                value: item.Id
              }, _toDisplayString(item.Name), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.PaperId]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                id: "User",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.Email) = $event)),
                type: "text",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.model.Email]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                disabled: _ctx.model.Email.length < 3,
                class: "btn m-2 btn-primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search()))
              }, " Search ", 8, _hoisted_12)
            ])
          ]),
          (_ctx.users.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "row left middle"
                  }, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(user.Email) + " - " + _toDisplayString(user.FullName), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("button", {
                        class: "btn m-2 btn-primary",
                        onClick: ($event: any) => (_ctx.selectUser(user))
                      }, " Select ", 8, _hoisted_16)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              id: "Ecommerce",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.Ecommerce) = $event)),
              type: "checkbox",
              class: "form-check-input"
            }, null, 512), [
              [_vModelCheckbox, _ctx.model.Ecommerce]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("input", {
              id: "Print",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.Print) = $event)),
              type: "checkbox",
              class: "form-check-input"
            }, null, 512), [
              [_vModelCheckbox, _ctx.model.Print]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", {
          disabled: _ctx.invalidInput,
          class: "btn m-2 btn-primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save()))
        }, " Save ", 8, _hoisted_23)
      ])
    ])
  ], 64))
}